const fixtures = {
  staticAppData: {
    frequencies: [
      {
        title: 'Single Clean',
        shortTitle: 'Once',
        name: 'once'
      },
      {
        title: 'Regular Clean',
        shortTitle: 'Regularly',
        shortDescription: 'Save 10%',
        name: 'regularly'
      }
    ],
    serviceTypes: [
      {
        title: 'Hotel Style',
        name: 'hotel-style',
        descriptions: []
      },
      {
        title: 'Deep Clean',
        name: 'deep-clean',
        descriptions: []
      }
    ],
    addons: [
      {
        title: 'Laundry Clean',
        name: 'laundry-clean'
      },
      {
        title: 'Fridge Clean',
        name: 'fridge-clean'
      },
      {
        title: 'Oven Clean',
        name: 'oven-clean'
      },
      {
        title: 'Window Clean',
        name: 'window-clean'
      }
    ],
    packageTypes: {
      mix: {
        title: 'Mix & Match',
        icons: ['hotel-style', 'deep-clean']
      },
      classic: {
        title: 'classic',
        'hotel-style': 0,
        'deep-clean': 2,
        icons: ['deep-clean', 'deep-clean']
      },
      prestige: {
        title: 'prestige',
        'hotel-style': 4,
        'deep-clean': 0,
        icons: ['hotel-style', 'hotel-style', 'hotel-style', 'hotel-style']
      },
      signature: {
        title: 'Signature',
        'hotel-style': 3,
        'deep-clean': 1,
        icons: ['deep-clean', 'hotel-style', 'hotel-style', 'hotel-style']
      }
    }
  },
  user: {
    userID: 30,
    firstName: 'Lim',
    lastName: 'Howe',
    email: 'dev@theminte.com',
    phone: '123456',
    createdAt: '2019-08-22T22:34:13.964Z',
    role: 'member',
    status: 'active',
    dataSource: null,
    isSocial: null,
    facebookID: null,
    googleID: null,
    regionID: null,
    lastLoggedAt: null,
    hasPets: true,
    optInNewsLetter: true,
    customerID: null,
    ccLast4: null,
    ccExpiry: null,
    ccBrand: null,
    isApplePay: null,
    isGooglePay: null,
    propertyID: null,
    bedroomsCount: null,
    buildingName: null,
    isVIP: null,
    isTextNotificationAllow: null,
    unitNumber: null,
    isKeyReleaseSigned: null,
    password: '123456'
  },
  cleans: [
    {
      frequency: 'regularly',
      bookingID: 14,
      serviceType: 'hotel-style',
      additionalService: [
        'laundry-clean',
        'fridge-clean',
        'oven-clean',
        'window-clean'
      ],
      timeframe: 'anytime',
      notes: '',
      price: 180,
      serviceDate: '2019-06-12T00:00:00.000Z',
      status: 'pending',
      couponID: 1,
      propertyID: 1,
      memberID: 1,
      createdAt: '2019-08-15T19:00:18.556Z'
    },
    {
      frequency: 'once',
      bookingID: 15,
      serviceType: 'hotel-style',
      additionalService: [
        'laundry-clean',
        'fridge-clean',
        'oven-clean',
        'window-clean'
      ],
      timeframe: 'anytime',
      notes: '',
      price: 180,
      serviceDate: '2019-06-22T00:00:00.000Z',
      status: 'pending',
      couponID: 1,
      propertyID: 1,
      memberID: 1,
      createdAt: '2019-08-15T19:00:18.556Z'
    },
    {
      frequency: 'once',
      bookingID: 16,
      serviceType: 'hotel-style',
      additionalService: [
        'laundry-clean',
        'fridge-clean',
        'oven-clean',
        'window-clean'
      ],
      timeframe: 'anytime',
      notes: '',
      price: 180,
      serviceDate: '2019-06-14T00:00:00.000Z',
      status: 'pending',
      couponID: 1,
      propertyID: 1,
      memberID: 1,
      createdAt: '2019-08-15T19:00:18.556Z'
    }
  ],
  keyReleaseInfo: {
    keyRelease: '',
    keyReleaseEmail: '',
    isKeyReleaseSigned: false
  },
  availableDates: {
    availabilities: {
      '2019-01-12': {
        mornging: true,
        evening: false
      },
      '2019-01-13': {
        mornging: true,
        evening: false
      },
      '2019-01-14': {
        mornging: true,
        evening: true
      },
      '2019-01-15': {
        mornging: false,
        evening: true
      },
      '2019-01-16': {
        mornging: true,
        evening: true
      },
      '2019-01-17': {
        mornging: true,
        evening: false
      },
      '2019-01-19': {
        mornging: true,
        evening: true
      }
    }
  },
  propertiesList: {
    pagination: {
      count: 4,
      pages: 1,
      currentPage: 1
    },
    properties: [
      {
        propertyID: 1,
        name: 'property name',
        address: 'address',
        city: 'kensas',
        state: 'chicago',
        zipcode: '61111',
        regionID: null,
        status: 'active',
        firstDayOfService: '2019-09-15T18:13:22.207Z',
        activeAt: '2019-09-15T18:13:22.210Z',
        unitsCount: 150,
        keyRelease:
          'I, [firstName] [lastName], sample text goes here and my unit is [unitNumber]',
        keyReleaseEmail: 'admin@email.com',
        isBuildingRequired: true,
        buildingsNames: ['building 1', 'building 2'],
        bedroomsCounts: [1, 2]
      },
      {
        propertyID: 2,
        name: 'Asus',
        address: 'address',
        city: 'kensas',
        state: 'chicago',
        zipcode: '61111',
        regionID: null,
        status: 'active',
        firstDayOfService: '2019-09-16T18:33:14.497Z',
        activeAt: '2019-09-16T18:33:14.497Z',
        unitsCount: 100,
        keyRelease:
          'I, [firstName] [lastName], sample text goes here and my unit is [unitNumber]',
        keyReleaseEmail: 'admin@email.com',
        isBuildingRequired: true,
        buildingsNames: ['building 1', 'building 2'],
        bedroomsCounts: [1, 2]
      },
      {
        propertyID: 3,
        name: 'HP',
        address: 'address',
        city: 'kensas',
        state: 'chicago',
        zipcode: '61111',
        regionID: null,
        status: 'active',
        firstDayOfService: '2019-09-16T18:33:14.497Z',
        activeAt: '2019-09-16T18:33:14.497Z',
        unitsCount: 200,
        keyRelease:
          'I, [firstName] [lastName], sample text goes here and my unit is [unitNumber]',
        keyReleaseEmail: 'admin@email.com',
        isBuildingRequired: false,
        buildingsNames: null,
        bedroomsCounts: [1, 2, 4]
      },
      {
        propertyID: 4,
        name: 'Apple',
        address: 'address',
        city: 'kensas',
        state: 'chicago',
        zipcode: '61111',
        regionID: null,
        status: 'active',
        firstDayOfService: '2019-09-16T18:33:14.497Z',
        activeAt: '2019-09-16T18:33:14.497Z',
        unitsCount: 777,
        keyRelease:
          'I, [firstName] [lastName], sample text goes here and my unit is [unitNumber]',
        keyReleaseEmail: 'admin@email.com',
        isBuildingRequired: false,
        buildingsNames: null,
        bedroomsCounts: [1, 2, 3]
      }
    ]
  }
};

export default fixtures;
